var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-tree-table"},[(false)?_c('div',{staticClass:"router-title-box"},[_c('a',{staticClass:"router-title-back cursor-pointer",attrs:{"href":"javascript:void(0);","title":"返回首页"},on:{"click":_vm.closeRouter}}),_vm._v(" "),_c('div',{staticClass:"router-title-tit"})]):_vm._e(),_vm._v(" "),_c('HomePage',{ref:"HomePage"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644aa43c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/system-outdoor/home/Home.vue
// module id = null
// module chunks = 